import {useForm} from "react-hook-form";
import {useEffect, useRef, useState} from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import countries from "../../../Assets/Files/countries.json"
import { useDispatch, useSelector } from "react-redux";
import { InternationalActions } from "../../../store/International_Slice";
import { CostData } from "../../../store/InternationalAction";

const ReceiverForm = ({setTab}) => {
    const form = useRef(null);
    const {register, reset, handleSubmit, formState: {errors}} = useForm();
    const [isClear, setIsClear] = useState(false);
    const [countryError,setcountryError]=useState(false)
    const dispatch=useDispatch()
    const {
        Sender,
        SenderCountry,
        Receiver,
        ReceiverCountry,
        PriceDetails,
        isLoading} = useSelector((state)=>state.International)

   
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [country, setCountry] = useState("");

    const [showCountriesSuggestions, setShowCountriesSuggestions] = useState(false);
    const [countriesSuggestions, setCountriesSuggestions] = useState([]);

    useEffect(() => {
        AOS.init({
            duration: 2000
        });
    }, []);

    useEffect(()=>{
        if(Receiver!==''){
            setCountry(ReceiverCountry)
            reset(Receiver)
        }
    },[Receiver,ReceiverCountry,reset])


    const onSubmit = data => {
        if(country===''){
            setcountryError(true)
        }
        if (country!=='' && data) {
            dispatch(InternationalActions.GetReceiver(data))
            dispatch(InternationalActions.GetReceiverRegion(country))
            dispatch(CostData(Sender,SenderCountry,Receiver,ReceiverCountry))
            // setTab(pre => pre + 2);
            setIsClear(true)
          } else setIsClear(false)
    };


    const Next = () => {
        setTab(2)
      }
    

    const selectCountry = (location) => {
        setCountry(location);
        setShowCountriesSuggestions(false);
    }

    const searchCountry = (query) => {
        setCountry(query);

        if (query === ""){
            setShowCountriesSuggestions(false);
            return;
        }

        const filteredCountries = [];
        countries.map((country) => {
            if (country["name"].toLowerCase().startsWith(query.toLowerCase())){
                filteredCountries.push(country["name"]);
            }
        });

        setCountriesSuggestions(filteredCountries);
        if (filteredCountries.length > 0){
            setShowCountriesSuggestions(true);
        } else {
            setShowCountriesSuggestions(false);
        }
    }

    return (
        <form data-aos="fade-zoom-in" onSubmit={handleSubmit(onSubmit)}>
            <div className="Top">
                <div className="Box">
                    <label htmlFor="first">FIRST NAME</label>
                    <input id="first" placeholder="First name"
                           className={`${errors.first_name ? 'error' : 'noError'}`} 
                           {...register("first_name", {required: true})} />
                    {errors.first_name &&
                        <span className={`${errors.first_name ? 'errorText' : ''}`}>First name is required</span>}
                </div>
                <div className="Box">
                    <label htmlFor="last">LAST NAME</label>
                    <input id="last" placeholder="last name"
                           className={`${errors.last_name ? 'error' : 'noError'}`}
                           {...register("last_name", {required: true})} />
                    {errors.last_name &&
                        <span className={`${errors.last_name ? 'errorText' : ''}`}>Last name is required</span>}
                </div>
            </div>
            <div className="Box">
                <label htmlFor="address">ADDRESS 1</label>
                <input id="address" placeholder="Address" value={address1}
                       className={`${errors.street ? 'error' : 'noError'}`}
                       {...register("address", {required: true, onChange:(e) => setAddress1(e.target.value)})} />
                {errors.address &&
                    <span className={`${errors.address ? 'errorText' : ''}`}>Address field is required</span>}
            </div>
            <div className="Box">
                <label htmlFor="house">ADDRESS 2 (Optional)</label>
                <input id="house" placeholder="Address 2 (Optional)"
                       {...register("address2", {onChange:(e) => setAddress2(e.target.value)})}
                       className={`${errors.address2 ? 'error' : 'noError'}`}  />
            </div>
            <div className="Box">
                <label htmlFor="country">COUNTRY</label>
                <input id="country" placeholder="Country" value={country}
                       className={`${countryError ? 'error' : 'noError'}`}
                       onChange={(e) => searchCountry(e.target.value)} />
                {countryError &&
                    <span className={`${countryError ? 'errorText' : ''}`}>Country is required</span>}
                <div style={{width:"86%"}} className={`suggestions-field ${showCountriesSuggestions ? "suggestions-field-visible" : null}`}>
                    {
                        countriesSuggestions.map((suggestions) => {
                            return(
                                <div onClick={(e) => selectCountry(suggestions, "Pickup")} key={suggestions} className="single-suggestion">
                                    <span style={{fontSize:14, color:"#74788d"}}>{suggestions}</span>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
            <div className="Top">
                <div className="Box">
                    <label htmlFor="CITY">STATE</label>
                    <input id="STATE" placeholder="State"
                           className={`${errors.state ? 'error' : 'noError'}`}
                           {...register("state", {required: true})} />
                    {errors.state && <span className={`${errors.state ? 'errorText' : ''}`}>State  is required</span>}
                </div>
                <div className="Box">
                    <label htmlFor="CITY">CITY</label>
                    <input id="City" placeholder="City" 
                           className={`${errors.city ? 'error' : 'noError'}`}
                           {...register("city", {required: true,})} />
                    {errors.city && <span className={`${errors.city ? 'errorText' : ''}`}>City is required</span>}
                </div>
            </div>
            <div className="Top">
                <div className="Box">
                    <label htmlFor="CITY">POSTCODE</label>
                    <input id="STATE" placeholder="Postcode"
                           className={`${errors.postcode ? 'error' : 'noError'}`}  
                           {...register("postcode", {required: true})} />
                    {errors.postcode && <span className={`${errors.postcode ? 'errorText' : ''}`}>Postcode is required</span>}
                </div>
                <div className="Box">
        <label htmlFor="PHONE NUMBER">EMAIL</label>
        <input
          id="phone-number"
          type="email"
          placeholder="Email"
          className={`${errors.recipient_email ? 'error' : 'noError'}`}
          {...register('recipient_email', { required: true })}
        />
        {errors.recipient_email && (
          <span className={`${errors.recipient_email ? 'errorText' : ''}`}>
            Email field is required
          </span>
        )}
      </div>
                <div className="Box">
                    <label htmlFor="PHONE NUMBER">PHONE NUMBER</label>
                    <input id="phone-number" placeholder="Phone Number" 
                           className={`${errors.phone_number ? 'error' : 'noError'}`}
                           {...register("phone_number", {required: true,})} />
                    {errors.phone_number && <span className={`${errors.phone_number ? 'errorText' : ''}`}>Phone number is required</span>}
                </div>
            </div>
            {PriceDetails === '' &&
            (isLoading === true ? (
            <div
                style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                }}
                className="btn"
            >
                <span className="spinner-border spinner-grow-sm" />
            </div>
            ) : (
            <input type="submit" value="CALCULATE COST" />
            ))}
            {PriceDetails !== '' && (
                <div
                onClick={Next}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                className="btn"
                >
                CONTINUE
                </div>
            )}
        </form>
    );
}

export default ReceiverForm;